/* global axios */
import ApiClient from '../ApiClient';

class ConversationSlotValuesAPI extends ApiClient {
  constructor() {
    super('omni/conversation_slot_values', { accountScoped: true });
  }

  getByConversation(conversationId, botId) {
    return axios.get(this.url, {
      params: {
        conversation_id: conversationId,
        agent_bot_id: botId,
      },
    });
  }
}

export default new ConversationSlotValuesAPI();
